import Image, { type ImageProps, type StaticImageData } from 'next/image';
import GoogleSvg from 'public/img/icons/google.svg';

export const GoogleIcon = (props: Omit<ImageProps, 'alt' | 'src'>) => {
  return (
    <Image
      alt="Google"
      width={20}
      src={GoogleSvg as StaticImageData}
      {...props}
    />
  );
};
